/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { DatePicker } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(
    new Date('2023-05-27'),
  );
  const handleOnChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  return (
    <DatePicker
      textInputProps={{
        label: 'This one has a label',
        helpText: 'With help text',
        showRequiredOrOptionalLabel: false,
        isDisabled: false,
        isRequired: false,
        isReadOnly: false,
        isFluid: false,
        moreInformationText: 'With information icon text',
      }}
      timePickerProps={{
        timeInterval: 20,
        format: 'hh:mm aa',
        isDisabled: false,
        isRequired: false,
        isReadOnly: false,
        isFluid: false,
      }}
      reactDatePickerProps={{
        selected: selectedDate,
        onChange: handleOnChange,
        showTimeInput: true,
        popperProps: {
          strategy: 'fixed',
        },
      }}
    />
  );
};

export default Component;
